import Vue from 'vue'
import Setting from '@/setting'

const Base64 = require('js-base64').Base64;

let Tools = {}

Tools.extend = function (parent, child) {
  child = child || {}
  for (let prop in parent) {
    child[prop] = parent[prop]
  }
  return child
}

Tools.clone = function(obj){
	return JSON.parse(JSON.stringify(obj));
}

Tools.postForm = function(url,param,resultFn,isShowLoading){
	if(isShowLoading=== undefined || isShowLoading){
		Vue.prototype.$Message.loading({content: 'Loading...',duration: 0});
	}
	let post = Vue.abHttpUtil.postForm(url, param);

 	this.getResultData(post, data => {
 		if(isShowLoading=== undefined || isShowLoading){
 			Vue.prototype.$Message.destroy();
 		}
 		resultFn(data);
  	},true);
}

Tools.getResultData = function (defer, fn, msgType, errorFn,isFastJson) {
  defer.then(function (result) {
	  if(isFastJson){
		  result = Tools.FastJson.format(result);
	  }
    Tools.getResult(result, fn, msgType, null, errorFn)
  }, function (status) {
	  Vue.prototype.$Message.destroy();
    if (status == !0) {
    	Vue.prototype.$Message.error('加载失败！' + status)
    }
	if (errorFn) {
		errorFn(status)
	}
  }
  )
}

Tools.getResultMsg = function (defer, fn, errorFn,msgType) {
  defer.then(function (result) {
    Tools.getResult(result, fn, msgType, msgType, errorFn)
  }, function (status) {
    if (errorFn) {
      errorFn(status)
    }
    Vue.prototype.$Message.error('加载失败！' + status)
  }
  )
}

Tools.getResult = function (result, fn, errMsgType, sucMsgType, errorFn) {
  if (typeof (result) !== 'object') {
    if (!result.startWith('{') && !result.startWith('[')) {
      result = { 'isOk': false, msg: '服务器反馈数据格式存在异常，无法解析反馈结果！', 'cause': result }
    } else {
      result	= eval('(' + result + ')')
    }
  }

  // 失败的提示
  if (!result.isOk) {
	  // 登录超时不允许出现alert
	  if(result.code=== "401"){
		  errMsgType = "toast";
		if(!this.loginToast){
			return;
		}
	  }

    // 去掉errorCode提示
    if(result.msg && result.msg.indexOf("errorCode")>=0){
      result.msg = result.msg.split("] : ")[1];
    }
    if (!errMsgType || errMsgType === 'toast') {
      Vue.prototype.$Message.error(result.msg)
      if (errorFn) { errorFn(result) };
    } else if (errMsgType === 'alert') {
      Vue.prototype.$Modal.error({
        title: $t('page.common.promptMessage'),
        content: result.msg,
        onOk: errorFn
      })
    }
    console.error(result)
  } else {
    if (!sucMsgType) { // 不需要任何显示
      if (fn) {
        fn(result.data,result)
      }
    } else if (sucMsgType === 'toast') {
      Vue.prototype.$Message.success(result.msg)
      if (fn) {
        fn(result.data,result)
      }
    } else if (errMsgType === 'alert') {
      Vue.prototype.$Modal.success({
        title: $t('page.common.promptMessage'),
        content: result.msg,
        onOk: fn
      })
    }
  }
}

/**
 * <pre>
 * 根据一个枚举类的路径获取这个枚举的json形式，供前端使用
 * 使用例子:
 * ToolsController.getEnum('com.dstz.sys.persistence.enums.FieldControlType').then(function(data) {
 * 	$scope.FieldControlType = data;
 * });
 * ToolsController.getEnum('com.dstz.base.db.model.Column$TYPE').then(function(data) {
 * 	$scope.ColumnTYPE = data;
 * });
 * 注意！！如果枚举在类中间，那么路径如下：com.dstz.base.db.model.Column$TYPE
 * </pre>
 */
Tools.getEnum = function(path, listMode) {
	var data = {
		path : path,
		listMode : listMode
	};
	if (!listMode) {
		data.listMode = false;
	}
	return  Vue.abHttpUtil.postForm("/sys/tools/getEnum",data);
};

Tools.getConstant = function(path, key) {
	let data = {
			path : path,
			key : key ? key : ""
		};
	return Vue.abHttpUtil.postForm("/sys/tools/getConstant",data);
};

/**
 * 获取系统bean容器中的指定实现类map
 */
Tools.getInterFaceImpls = function(classPath) {
	let data = {
			classPath : classPath
		};
	return Vue.abHttpUtil.postForm("/sys/tools/getInterFaceImpls",data);
};

/**
 * 得到当前时间
 *
 * @param format 格式化
 */
Tools.getCurrentTime = function (format) {
	return Vue.abHttpUtil.postForm("/sys/tools/getCurrentTime",{'format': format});
};

/***
 * 将格式化数字转换成number
 */
Tools.toNumber = function (x) {
  if (x === null || x === undefined || x === '') return ''
  if (typeof x === 'string') {
    x = x.replace(/,/g, '')
  }
  let match = x.toString().match(/([$|￥])\d+\.?\d*/)
  if (match) {
    x = x.replace(match[1], '')
  }
  let val = Number(x)
  if (Number.isNaN(val)) return x
  return val
}

// 转成千分位。
Tools.comdify = function(v) {
	if (!v) return v;
	var n = v + "";
	var re = /\d{1,3}(?=(\d{3})+$)/g;
	var n1 = n.trim().replace(/^(\d+)((\.\d+)?)$/, function(s, s1, s2) {
				return s1.replace(re, "$&,") + s2;
			});
	return n1;
}
/**
 * 通过json的路径获取值。严格模式下无法使用eval
 */
Tools.getJsonValue = function xxx (json, path) {
  if (!json) return
  try {
    let array = path.split('.')
    let value = json
    for (let i = 0, k; k = array[i++];) {
      value = value[k]
    }
    return value
  } catch (e) {
    console.error('通过path 获取json的value 失败 ', e, json, path)
  }
}

Tools.CloneUtil = {
  /**
   * 深复制【可以迭代】
   */
  deep: function (obj) {
    return JSON.parse(JSON.stringify(obj));
  },
  /**
   * 浅复制【不能迭代】
   */
  shallow: function (obj) {
    return jQuery.extend({}, obj)
  },
  /**
   * 数组复制
   */
  list: function (obj) {
    return JSON.parse(JSON.stringify(obj));
  }
}

Tools.ArrayUtil = {
		//上移按钮
    	up:function(idx,list){
    		if(idx<1){
    			return;
    		}
    		var t=list[idx-1];
    		list[idx-1]=list[idx];
    		list[idx]=t;
    	},
    	//下移按钮
    	down:function(idx,list){
    		if(idx>=list.length-1){
    			return;
    		}
    		var t=list[idx+1];
    		list[idx+1]=list[idx];
    		list[idx]=t;
    	},
    	resumeSn:function(list){
    		for(var k = 0 ; k < list.length ; k++){
    			list[k].sn = k;
			}
    		return list;
    	},
    	/**
    	 * idx 原位置
    	 * num 目标位置
    	 * list 数组
    	 */
    	moveToNum:function(idx,target,list){
    		if(target==-1){
    			target = 0;
    		}else if(idx >= target){
    			target = target+1;
    		}
    		var t= list.splice(idx,1);
    		list.insert(target,t[0]);
    		this.resumeSn(list);
    	},
    	//默认ngModel turnToIndex
    	turnTo:function(rowScope,list){
    		var toIndex =rowScope.turnToIndex - 1;
    		if(!rowScope.turnToIndex || toIndex<0 || toIndex>=list.length) return;

    		var index = rowScope.$index;
    		if(toIndex == index) return;

    		var row= list.splice(index,1);
    		list.insert(toIndex,row[0]);

    		rowScope.turnToIndex= "";
    	},
    	//删除按钮
    	del:function(idx,list){
    		list.splice(idx,1);
    	},
    	//找到指定元素的未知
    	idxOf:function(val,list){
    		for (var i = 0; i < list.length; i++) {
    	        if (list[i] == val) return i;
    	    }
    	    return -1;
    	},
    	//删除指定元素
    	remove:function(val,list){
    		var idx = this.idxOf(val,list);
    	    if (idx > -1) {
    	    	list.splice(idx, 1);
    	    }
    	},
    	//置顶
    	top:function(idx,list){
    		if(idx>=list.length || idx<1){
    	           return;
    		}
    		//逐个交换
            for(var i=0;i<idx;i++){
	            var temp=list[i];
	            list[i]=list[idx];
	            list[idx]=temp;
            }
    	},
    	//置底
    	bottom:function(idx,list){
    		if(idx>=list.length-1 || idx<0){
                return;
            }
            //逐个交换
            for(var i=list.length-1;i>idx;i--){
                var temp=list[i];
                list[i]=list[idx];
                list[idx]=temp;
            }
    	}
    };

/**
 * 引入fastjson
 */
Tools.FastJson = {
	isArray : function(a) {
		return "object" == typeof a && "[object array]" == Object.prototype.toString.call(a).toLowerCase()
	},
	isObject : function(a) {
		return "object" == typeof a && "[object object]" == Object.prototype.toString.call(a).toLowerCase()
	},
	format : function(a) {
		if (null == a)
			return null;
		"string" == typeof a && (a = eval("(" + a + ")"));
		return this._format(a, a, null, null, null)
	},
	_randomId : function() {
		return "randomId_" + parseInt(1E9 * Math.random())
	},
	_getJsonValue : function(a, c) {
		c = c.replace(/\\/g,"");//ab修复fastjson1.2.51以上的\ 的bug
		var d = this._randomId(), b;
		b = "" + ("function " + d + "(root){") + ("return root." + c + ";");
		b += "}";
		b += "";
		var e = document.createElement("script");
		e.id = d;
		e.text = b;
		document.body.appendChild(e);
		d = window[d](a);
		e.parentNode.removeChild(e);
		return d
	},
	_format : function(a, c, d, b, e) {
		d || (d = "");
		if (this.isObject(c)) {
			if (c.$ref) {
				var g = c.$ref;
				0 == g.indexOf("$.") && (b[e] = this._getJsonValue(a, g.substring(2)));
				return
			}
			for ( var f in c)
				b = d, "" != b && (b += "."), g = c[f], b += f, this._format(a, g, b, c, f)
		} else if (this.isArray(c))
			for (f in c)
				b = d, g = c[f], b = b + "[" + f + "]", this._format(a, g, b, c, f);
		return a
	}
};

/**
 * 判断开始是否相等
 *
 * @param str
 * @param isCasesensitive
 * @returns {Boolean}
 */
String.prototype.startWith = function(str, isCasesensitive) {
	if (str == null || str == "" || this.length == 0
			|| str.length > this.length)
		return false;
	let tmp = this.substr(0, str.length);
	if (isCasesensitive == undefined || isCasesensitive) {
		return tmp == str;
	} else {
		return tmp.toLowerCase() == str.toLowerCase();
	}
};

/**
 * 格式化字符串
 * eg: let aaa = "myName is {name} my wife name is {wife.name}".format({"name":"苗继方",wife:{name:"柠檬"})
 *    alert (aaa);
 */
String.prototype.format = function (context) {
	  return _stringRender(this, context);
};

window._stringRender = function(template, scopeData) {
  let tokenReg = /(\\)?\{([^\{\}\\]+)(\\)?\}/g;

  return template.replace(tokenReg, function (word, slash1, token, slash2) {
    if (slash1 || slash2) {
      return word.replace('\\', '');
    }

    let letiables = token.replace(/\s/g, '').split('.');

    if(word.startWith("{url.")){
    	return $.getParam(letiables[1]);
    }
    let currentObject = scopeData;
    let i, length, letiable;

    for(let i=0,key;key=letiables[i++];){
    	currentObject = currentObject[key];
    	if (currentObject === undefined || currentObject === null) return '';
    }

    return currentObject;
  })
};

/**
 * 字符串替换
 *
 * @param s1
 *            需要替换的字符
 * @param s2
 *            替换的字符。
 * @returns
 */
String.prototype.replaceAll = function(s1, s2) {
	return this.replace(new RegExp(s1, "gm"), s2);
};


/**
 * 日期格式化。
 * 日期格式：
 * yyyy，yy 年份
 * MM 大写表示月份
 * dd 表示日期
 * HH 表示小时
 * mm 表示分钟
 * ss 表示秒
 * q  表示季度
 * 实例如下：
 * let now = new Date();
 * let nowStr = now.format("yyyy-MM-dd HH:mm:ss");
 */
Date.prototype.format = function(format){
	let o = {
		"M+" : this.getMonth()+1, //month
		"d+" : this.getDate(), //day
		"H+" : this.getHours(), //hour
		"m+" : this.getMinutes(), //minute
		"s+" : this.getSeconds(), //second
		"q+" : Math.floor((this.getMonth()+3)/3), //quarter
		"S" : this.getMilliseconds() //millisecond
	}

	if(/(y+)/.test(format)) {
		format = format.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
	}

	for(let k in o) {
		if(new RegExp("("+ k +")").test(format)) {
			format = format.replace(RegExp.$1, RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));
		}
	}
	return format;
}


/**
 * 求当前时间到指定时间的差（当前时间是起点）
 * type:date 天数;month:月数;year:年数;hour：小时
 */
Date.prototype.between = function(date,type) {
	if(!type){
		type = "date";
	}
	if(type=="hour"){
		let dateSpan = date.getTime() - this.getTime();
		return Math.floor(dateSpan / (3600 * 1000));
	}
	if(type=="date"){
		let dateSpan = date.getTime() - this.getTime();
		return Math.floor(dateSpan / (24 * 3600 * 1000));
	}
	if(type=="month"){
		return (date.getFullYear()-this.getFullYear()) * 12 + (date.getMonth()-this.getMonth());
	}
	if(type=="year"){
		return date.getFullYear()-this.getFullYear();
	}

};

/**
 * 字符串根据某个格式转化成日期
 * yyyy-MM-dd HH:mm:ss
 */
String.prototype.toDate = function(format) {
	if(!format){
		format = "yyyy-MM-dd";
	}
	let year = String_toDate(this,format,"yyyy")
	let month = String_toDate(this,format,"MM");
	let day = String_toDate(this,format,"dd");
	let hour = String_toDate(this,format,"HH");
	let minth = String_toDate(this,format,"mm");
	let second = String_toDate(this,format,"ss");
	let date = new Date(0);
	date.setFullYear(year||1);
	date.setMonth(parseInt(month||1)-1);
	date.setDate(day||1);
	date.setHours(hour||0);
	date.setMinutes(minth||0);
	date.setSeconds(second||0);
	return date;
};
function String_toDate(str,format,a){
	if(format.indexOf(a)==-1){
		return null;
	}
	return str.substr(format.indexOf(a),a.length);
}


Tools.timeLag = function(difference,level){
	var  r ="",
	////计算出相差天数
	days=Math.floor(difference/(24*3600*1000)),
	//计算出小时数
	leave1=difference%(24*3600*1000),   //计算天数后剩余的毫秒数
	hours=Math.floor(leave1/(3600*1000)),
	//计算相差分钟数
	leave2=leave1%(3600*1000),      //计算小时数后剩余的毫秒数
	minutes=Math.floor(leave2/(60*1000)),
	//计算相差秒数
	leave3=leave2%(60*1000),    //计算分钟数后剩余的毫秒数
	seconds=Math.round(leave3/1000);

	if(!level){
		level = 2;
	}
	if(days>0){
		level--;
		r +=days+"天";
		if(level==0)return r;
	}
	if(hours>0){
		level--;
		r +=hours+"时";
		if(level==0)return r;
	}
	if(minutes>0){
		level--;
		r +=minutes+"分";
		if(level==0)return r;
	}
	if(seconds>0){
		level--;
		r +=seconds+"秒";
		if(level==0)return r;
	}

	if(r){
		return r;
	}

	if(leave3){
		return difference+"毫秒";
	}

	return ""
}



//====================liuhaijiang=========================

//获取用户所属（主所属） - 公司
Tools.getCurUserCompany = function(userId,call){

	let url = "/sys/getCurUserCompany";
	let post = Vue.abHttpUtil.post(url,{userId:userId});
	Tools.getResultData(post, (data,result) => {
		if(call){
			call(data,result);
		}
	});

}

//获取当前用户所属（当前所属） - 公司
Tools.getCurUserCurCompany = function(call){

	let url = "/sys/getCurUserCurCompany";
	let post = Vue.abHttpUtil.post(url,{});
	Tools.getResultData(post, (data,result) => {
		if(call){
			call(data,result);
		}
	});

}

//获取用户选择所属 - 公司
Tools.getCurGroupCompany = function(groupId, call){

	let url = "/sys/getCurGroupCompany";
	let post = Vue.abHttpUtil.postForm(url,{groupId:groupId});
	Tools.getResultData(post, (data,result) => {
		if(call){
			call(data,result);
		}
	});

}

//判断是否有该字段权限
Tools.pageConfigIsNoAuth = (tablePermission,permission,tableKey,fieldKey)=>{
	let flag = false;
	if(tableKey && tablePermission && Object.keys(tablePermission).length>0){
	  if(tablePermission[tableKey]=='n'){
		flag = true;
	  }
	}
	if(tableKey && fieldKey && permission && Object.keys(permission).length>0){
	  if(permission[tableKey] && permission[tableKey][fieldKey]=='n'){
		flag = true;
	  }
	}
	return flag;
}
//是否存在某个功能权限
Tools.hanSysFunction = (this_,fieldKey)=>{
	let flag = true;
	//获取系统功能 - 配置
	let sysConfig =  this_.$store.state.admin.pageAuthConfig.datas;
	if(sysConfig && sysConfig.sclmMSysFunction){
		let sclmMSysFunction = sysConfig.sclmMSysFunction;
		//是否开启OOS
		flag = !Tools.pageConfigIsNoAuth(sclmMSysFunction.tablePermission,sclmMSysFunction.permission,'sclmMSysFunction',fieldKey);
	}
	return flag;
}


/**
 * 跳转office在线编辑预览页面
 */
Tools.openOfficeWindow = function(this_,row,isReadonly=false){
	console.log(this_.abJwtSetting.getHeader());
	var match = document.cookie.match(new RegExp('(^| )Authorization=([^;]+)'));
	var authorizationData = ''
	if(match) {
		authorizationData = decodeURIComponent(match[2])
	}
	let routeUrl = this_.$router.resolve({
		path: "/office/online",
		query: {
			...row,
			...{isReadonly:isReadonly},
		},
		params:{
			'Authorization':authorizationData
		}
	});
	window.open(routeUrl.href, '_blank',"width=1920,height=1080,menubar=0,scrollbars=1,resizable=1,status=1,titlebar=0,toolbar=0,location=1");

}

/**
 * 跳转wps在线编辑预览页面
 */
Tools.openWpsOfficeWindow = function(this_,row,isReadonly=false){
	// 根据是否只读设置mode参数
	let mode = isReadonly ? 'simple' : 'nomal';
	let pageUrl = `/wps/index.html?isReadonly=${isReadonly}&fileId=${row.id}&mode=${mode}`;
	let authorization = this_.$route.query.Authorization;
	if(authorization){
		pageUrl += "&Authorization="+authorization;
	}else{
		var match = document.cookie.match(new RegExp('(^| )Authorization=([^;]+)'));
		if(match) {
			authorization = decodeURIComponent(match[2])
		}
		pageUrl += "&Authorization="+authorization;
	}
	window.open(pageUrl, '_blank',"width=1920,height=1080,menubar=0,scrollbars=1,resizable=1,status=1,titlebar=0,toolbar=0,location=1");
}

/**
 * 跳转固定模板在线编辑预览页面
 */
Tools.openDocTempEdit = function(this_,finfo={},fixedTempPermission=r,pageType,formData={}){

	let formDataId = "";
	if(formData && formData.id){
		formDataId = formData.id;
	}else{
		formDataId = Tools.getUuId();
	}
	if(formData && Object.keys(formData).length>0){
		sessionStorage.setItem(formDataId, JSON.stringify(formData));
	}

	//base64加密
	let fileInfo = Base64.encode(JSON.stringify(finfo));

	let routeUrl = this_.$router.resolve({
		//path: "/fileTemp/edit",
		name:'fileTempEdit',
		query: {
			fileInfo:fileInfo,
			fixedTempPermission:fixedTempPermission,
			pageType:pageType,
			formDataId:formDataId
		},
		params:{

		}
	});
	let pageUrl = routeUrl.href;
	let authorization = this_.$route.query.Authorization;
	if(authorization){
		pageUrl += "&Authorization="+authorization;
	}

	window.open(pageUrl, '_blank',"width=1920,height=1080,menubar=0,scrollbars=1,resizable=1,status=1,titlebar=0,toolbar=0,location=1");

}

/**
 * pdf预览
 */
Tools.toPdfView = function(this_,fileId){

	let routeUrl = this_.$router.resolve({
		path: "/pdf/pdfview",
		query: {
			fileId:fileId
		}
	});
	window.open(routeUrl.href);
}

/**
 * 查看文件对比情况
 */
Tools.toFileDiffResult = function(this_,diffId){
	let routeUrl = this_.$router.resolve({
		name: 'ocrFileDiffResult',
		query: {diffId:diffId}
	})
	let pageUrl = routeUrl.href;
	let authorization = this_.$route.query.Authorization;
	if(authorization){
		pageUrl += "&Authorization="+authorization;
	}
	window.open(pageUrl, '_blank',"width=1920,height=1080,menubar=0,scrollbars=1,resizable=1,status=1,titlebar=0,toolbar=0,location=1");
}

/**
 * 合同履历信息
 */
 Tools.showContractEditHistory = function(this_,fileId){

	let routeUrl = this_.$router.resolve({
		path: "/master/sclmMDocEditHistory",
		query: {
			fileId:fileId
		}
	});
	window.open(routeUrl.href,'_blank',"width=800,height=1080,menubar=0,scrollbars=1,resizable=1,status=1,titlebar=0,toolbar=0,location=1");

}

/**
 * 获取文件类型
 */
Tools.getFileType = function(fileName){
	let fileType = '';
	if(fileName){
		let index= fileName.lastIndexOf(".");
    	fileType = fileName.substring(index+1).toLowerCase();
	}
	return fileType;
}
/**
 * 获取文件名
 */
Tools.getFileName = function(fileName){
	let fileType = '';
	if(fileName){
		let index= fileName.lastIndexOf(".");
    	fileType = fileName.substring(0,index);
	}
	return fileType;
}

/**
 * 是否图片
 */
Tools.fileIsImg = function(fileName){
	let fileType = Tools.getFileType(fileName);
	return Tools.getImgTypes().includes(fileType);
}
Tools.fileIsOffice = function(fileName){
	let fileType = Tools.getFileType(fileName);
	return Tools.getOfficeTypes().includes(fileType);
}
Tools.fileIsOfficeEdit = function(fileName){
	let fileType = Tools.getFileType(fileName);
	return Tools.getOfficeEditTypes().includes(fileType);
}
/**
 * office可编辑文件集合
 */
Tools.getOfficeEditTypes = function(){
	return ['docx','xlsx','pptx'];
}
/**
 * office文件集合
 */
Tools.getOfficeTypes = function(){
	return ['doc','docx','xls','xlsx','ppt','pptx'];
}
/**
 * 图片类型集合
 */
Tools.getImgTypes = function(){
	return ['webp','bmp','jpg','jpeg','png','tif','gif'];
}

/**
 * 获取cookie
 */
Tools.getCookie = function(name){
	let map = {};
	let cookie = document.cookie.split(';');
	if(cookie.length == 0){
		return;
	}
	for (let i = 0; i < cookie.length; i++) {
	  var c = cookie[i];
	  let split = c.split('=');
	  let key = split[0].trim();
	  let value = split[1].trim();
	  map[key] = value;
	  if(name && name==key){
		return value;
	  }
	}

	return map;
}

/**
 * 根据组件名称获取父组件
 */
Tools.getParentComponent = function(this_,componentName){

	if(!this_ || !componentName){
		return;
	}

	let parent = this_.$parent;
	let flag = parent?true:false;
	let i=0;
	while(flag && i<=20){
		if(parent.$options && componentName==parent.$options.name){
			flag = false;
			return parent;
		}
		parent = parent.$parent;
		flag = parent?true:false;
	}
	i++;
    return;
}

/**
 * list 多个字段排序
 * list.sort((a,b)=>{return this.abTools.sortByProps(a,b,{"name":"asc"})});
 */
Tools.sortByProps = function(item1, item2, obj){
	// 多字段排序
	//asc升序 desc 降序
	var props = [];
	if (obj) {
		props.push(obj);
	}
	var cps = [], // 存储排序属性比较结果。
	// 如果未指定排序属性(即obj不存在)，则按照全属性升序排序。
	// 记录下两个排序项按照各个排序属性进行比较得到的结果
	asc = true;

	function handleNull(val) {
		return val === '' || val === null;
	}
	if (props.length < 1) {
		for (var p in item1) {
			let a1, b1;
			a1 = item1[p];
			b1 = item2[p];
			if (handleNull(a1) && handleNull(b1)) {
				cps.push(0);
			} else if (handleNull(a1) && !handleNull(b1)) {
				cps.push(1);
				break;
			} else if (!handleNull(a1) && handleNull(b1)) {
				cps.push(-1);
				break; // 小于时跳出循环。
			} else {
				if (a1 > b1) {
					cps.push(1);
					break; // 大于时跳出循环。
				} else if (a1 === b1) {
					cps.push(0);
				} else {
					cps.push(-1);
					break; // 小于时跳出循环。
				}
			}
		}
	} else {
		for (var i = 0; i < props.length; i++) {
			var prop = props[i];
			for (var o in prop) {
				asc = prop[o] === 'asc';
				let a2, b2;
				a2 = item1[o];
				b2 = item2[o];
				if (handleNull(a2) && handleNull(b2)) {
					cps.push(0);
				} else if (handleNull(a2) && !handleNull(b2)) {
					cps.push(asc ? 1 : -1);
					break; // 大于时跳出循环。
				} else if (!handleNull(a2) && handleNull(b2)) {
					cps.push(asc ? -1 : 1);
					break; // 小于时跳出循环。。
				} else {
					if (a2 > b2) {
						cps.push(asc ? 1 : -1);
						break; // 大于时跳出循环。
					} else if (a2 === b2) {
						cps.push(0);
					} else {
						cps.push(asc ? -1 : 1);
						break; // 小于时跳出循环。。
					}
				}
			}
		}
	}
	// 根据各排序属性比较结果综合判断得出两个比较项的最终大小关系
	for (var j = 0; j < cps.length; j++) {
		if (cps[j] === 1 || cps[j] === -1) {
			return cps[j];
		}
	}
	return false;
}

/**
 * 数字签名补0
 */
Tools.supplement = function(num,length){
	return (Array(length).join("0") + num).slice(-length);
}

/**
 * 日期加天数/月数/年数
 */
Tools.dateAddDay = function(date,number,type='day'){
	if(!date || !number){
		return date;
	}

	if(type=='day'){
		//添加天数
		date.setDate(date.getDate() + number);
	}
	if(type=='month'){
		//添加月数
		date.setMonth(date.getMonth() + number);
	}
	if(type=='year'){
		//添加年数
		date.setYear(date.getYear() + number);
	}

    return date;
}

Tools.getUserDetail = function(userId,call){
	if(!userId){
		return;
	}
	let url = "/org/user/get";
	let post = Vue.abHttpUtil.postForm(url, {
		id : userId,
	});
	Tools.getResultData(post, (data,result) => {
		if(data){
			call(data);
		}
	});
},

/**
 * 获取字典数据
 */
Tools.getDict = function(dictKey,call){

	let url = "/sys/dataDict/getDictData";
	let post = Vue.abHttpUtil.postForm(url, {
		dictKey : dictKey
	});
	Tools.getResultData(post, data => {
		if(data && data.length>0){
			call(data);
		}
	});
}
Tools.getDictByKeys = function(dictKeys,call){
	let url = "/sys/dict/getDictByKeys";
	let post = Vue.abHttpUtil.post(url, dictKeys);
	Tools.getResultData(post, data => {
		if(data){
			call(data);
		}
	});
}
//获取所有数据字段-接口无权限
Tools.getAllDictData = function(call){
	let url = "/public/sys/getAllDictData";
	let post = Vue.abHttpUtil.postForm(url, {});
	Tools.getResultData(post, data => {
		if(call){
			call(data);
		}
	});
}

//获取流水号
Tools.getSerialNo = function(alias,call){
	let url = "/sys/serialNo/getNextIdByAlias";
	let post = Vue.abHttpUtil.postForm(url, {
		alias: alias
	});
	Tools.getResultData(post, data => {
		call(data);
	});
}

//根据业务id,业务对key获取业务对象数据
Tools.getBusData = function(params,call = {}){

	/* 参数：{
		id:'',
		boKey: "bmsTItemTdReference" 业务对象key
	} */

	let url = '/business/getBusDataByKey';
	let post = Vue.abHttpUtil.postForm(url,params);
	Tools.getResultData(post, (data,result) => {
		if(data){
			call(data,result);
		}
	});
}

//根据业务id,业务对key获取业务对象数据
Tools.getBusDataAsync = async function(params = {}){

	/* 参数：{
		id:'',
		boKey: "bmsTItemTdReference" 业务对象key
	} */
	return new Promise((resolve, reject) => {
		let url = '/business/getBusDataByKey';
		let post = Vue.abHttpUtil.postForm(url,params);
		Tools.getResultData(post, (data,result) => {
			resolve(data,result);
		});
	});
}

//获取表单数据
Tools.getFormDataAsync = async function(params = {}){

	return new Promise((resolve, reject) => {
		let param = {...{
			/* id: "0"
			key:'',  */
			isReadOnly:'1',
			sql:'0'
		},...params};

		let url = "/form/formDefData/getData";
		let post = Vue.abHttpUtil.postForm(url,param);
		Tools.getResultData(post, (data,result) => {
			resolve(data);
		});
	});

}

//获取表单数据
Tools.getFormData = function(call,params = {}){

	let param = {...{
		/* id: "0"
		key:'',  */
		isReadOnly:'1',
		sql:'0'
	},...params};

	let url = "/form/formDefData/getData";
	let post = Vue.abHttpUtil.postForm(url,param);
	Tools.getResultData(post, (data,result) => {
		if(data){
			call(data,result);
		}
	});

}

//保存表单数据
Tools.saveFormData = function(key,params = {},call){

	let url = "/business/saveFormData/"+key;
	let post = Vue.abHttpUtil.post(url,params);
	Tools.getResultData(post, (data,result) => {
		if(call){
			call(data,result);
		}
	});

}

//删除表单数据
Tools.removeFormData = (formKey,id,call)=>{

	Tools.confirm($t('page.common.del'),()=>{
		let url = "/form/formDefData/removeData";
		if(formKey && id){
			url += '/'+formKey+'/'+id;
		}
		let post = Vue.abHttpUtil.postForm(url,{});
		Tools.getResultData(post, (data,result) => {
			if(data){
				//删除成功
				Vue.prototype.$Message.success($t('page.common.delSuccess'));
				if(call){
					call();
				}
			}
		});
	});

}

//逻辑删除表数据
Tools.updateDeleteFlag = (url,id,call)=>{

	Tools.confirm($t('page.common.del'),()=>{

		let post = Vue.abHttpUtil.post(url,{id:id,deleteFlag:'1'});
		Tools.getResultData(post, (data,result) => {
			if(data){
				//删除成功
				Vue.prototype.$Message.success($t('page.common.delSuccess'));
				if(call){
					call();
				}
			}
		});
	});

}

/**
 * 获取流程实例-详情页面数据
 */
Tools.getDetailInstanceData = async function(instanceId,call){

	return new Promise((resolve, reject) => {
		let param = {
			instanceId:instanceId,
			formType:'pc',
			readonly:'true'
		};

		let url = "/bpm/instance/getInstanceData";
		let post = Vue.abHttpUtil.postForm(url,param);
		Tools.getResultData(post, (data,result) => {
			if(call){
				call(data);
			}
			resolve(data);
		});
	});

}

/**
 * 获取当前用户权限
 */
Tools.getCurUserAuthorities = function(call){
	let url = "/sys/getCurrentUserAuthorities";
	let post = Vue.abHttpUtil.postForm(url, {
	});
	Tools.getResultData(post, data => {
		call(data);
	});
}

/**
 * 获取当前用户权限
 */
Tools.getCurUserAuthoritiesAsync = async function(){
	return new Promise((resolve, reject) => {
		Tools.getCurUserAuthorities(auths=>{
			resolve(auths);
		});
	});
}

/**
 * 用户是否存在某个角色
 */
Tools.existAuthorities = function(auths,call){

	if(!auths || auths.length<=0){
		call(false);
		return;
	}

	let url = "/sys/existAuthorities";
	let post = Vue.abHttpUtil.post(url, auths);
	Tools.getResultData(post, data => {
		call(data);
	});
}

/**
 * 是否系统管理员
 */
Tools.isSysManage = function(call){
	let url = "/sys/isSysManage";
	let post = Vue.abHttpUtil.post(url, {});
	Tools.getResultData(post, data => {
		call(data);
	});
}

/**
 * 是否存在菜单/按钮权限
 */
Tools.hasAuthBtn = function(code,this_){
	let flag = false;

	if(!code) {
		return flag;
	};

	try{
		let btnPermission = this_.$store.state.admin.user.info.buttonPermision;
		//console.log("btnPermission======",btnPermission);
		if(btnPermission && btnPermission[code]){
			flag = true;
		}
	}catch(e){

	}

	return flag;
}

//保留两位小数
Tools.toFixed = function(val,decimal=2){
	return Math.round(val * 100)/100;
}

//设置日期-范围查询检索条件
Tools.setDBT = function(val,searchParam,fieldName){
	if(val && val.length>=2){
		let start = val[0];
		let end = val[1];
		if(start && end){
			searchParam[fieldName + '$DBT'] = start;
			searchParam[fieldName + '-end$DBT'] = end + ' 23:59:59';
		}else{
			searchParam[fieldName + '$DBT'] = '';
			searchParam[fieldName + '-end$DBT'] = '';
		}
	}
}

//card卡片 展开/隐藏
Tools.cardOpenSwitch = function(e,parentLevel){
	let cardBody = e.currentTarget.parentElement.parentElement.nextElementSibling;
	if(parentLevel){
		cardBody = e.currentTarget;
		for (let index = 0; index < parentLevel; index++) {
			cardBody = cardBody.parentElement;
		}
		cardBody = cardBody.nextElementSibling;
	}
	if(cardBody.style.display=='none'){
		cardBody.style.display = 'block'
	}else{
		cardBody.style.display = 'none'
	}
}

//跳转到表单页面
Tools.toFormPreview = function(this_,key,id,isReadOnly=0,query={}){
	this_.$router.push({
		path:'/form/form/preview',
		query:{
			...{
				key: key,
				id:id,
				isReadOnly:isReadOnly,
				pageBack: 'true'
			}
		  	,...query
		}
	});
}
//跳转到流程启动页面
Tools.toFlowStart = function(this_,key,query={},params={}){
	this_.$router.push({
		//path:'/bpm/instance/start/'+key,
		name:'definitionStart',
		query:query,
		params:{flowKey:key,...params}
	});
}
//跳转到流程实例详情页面
Tools.toFlowInstanceDetail= function(this_,instanceId,params={},query={}){
	this_.$router.push({
		name:'instanceDetail',
		query:query,
		params:{id:instanceId,...params}
	});
}

//是否有编辑权限
Tools.isEdit = function(val){
	return val=='w' || val=='b';
}
//是否有显示权限
Tools.isShow = function(val){
	return val && val!='n';
}

//关闭当前页面
Tools.back = function(this_,backRouter){
	this_.$store.dispatch('admin/page/close', {
		tagName: this_.$route.fullPath,
		noSkip:true
	});

	let backRouter_ = this_.$route.query.backRouter;

	if(backRouter || backRouter_){
		this_.$router.push({
			name: (backRouter_ || backRouter),
			params: {
				reload: true,
			},
		})
	}else{
		if(this_.$router){
			this_.$router.back(-1);
		}else{
			window.history.back();
		}
	}
}

//附件上传字符串转换对象
Tools.attachFormat = function(val){
	// 附件字符串-格式化
	let files = []
	if (val) {
		try {
			files = JSON.parse(val)
		} catch (error) {}
	}
	return files
}


/**
 * 文件复制
 */
Tools.fileCopy = function(fileList,call){
	let url = "/sys/fileHandle/coypFile";
	let post = Vue.abHttpUtil.post(url, fileList);
	Tools.getResultData(post, data => {
		if(call){
			call(data);
		}
	});
}
/**
 * 文件转PDF-重新生成系统文件
 */
Tools.dbFileToPdfFile = function(fileList,call){
	let url = "/sys/dbFileToPdfFile";
	let post = Vue.abHttpUtil.post(url, fileList);
	Tools.getResultData(post, data => {
		if(call){
			call(data);
		}
	},'',err=>{
		if(call){
			call();
		}
	});
}

//文件下载
Tools.downloadFile = function(url,type,call){

	/*
	if(type=='sys'){
		url = Setting.apiBaseURL + "sys/sysFile/download?fileId=" + url;
	}
	const iframe = document.createElement("iframe");
	iframe.src = url;
	iframe.style.display = "none"; // 防止影响页面
	iframe.style.height = 0; // 防止影响页面
	document.body.appendChild(iframe); // 必写，iframe挂在到dom树上才会发请求
	// 定时删除节点
	setTimeout(() => {
		document.body.removeChild(iframe);
	}, 1000 * 60 * 20); */
	if(type=='sys'){
		url = "sys/fileDownload?fileId=" + url;
	}else{
		if(url.substring(0,5)=='/apis'){
			url = url.substring(5,url.length);
		}else if(url.substring(0,4)=='apis'){
			url = url.substring(4,url.length);
		}
	}
	Tools.postDownload(url,{},'',call);
}

//文件下载 post json请求
Tools.postDownload = function(url,params={},fileName,call){

	let post = Vue.abHttpUtil.postDownloadRes(url, params);

	post.then(
		response => {
			//console.log(response);
			let res = response.data;
			let headers = response.headers;
			//console.log(headers);

			if(res.type=='text/html'){
				let t = res.text();
				t.then(d=>{
					let json = JSON.parse(d);
					if(json.msg){
						Tools.error(json.msg);
					}
				});
			}else{
				var blob = new Blob([res], { type: "application/octet-stream" })
				var url = URL.createObjectURL(blob);
				var a = document.createElement("a");

				if(fileName){
					a.download = fileName;
				}else if(headers['file-name']){
					let fname = headers['file-name'];
					try {
						fname = Base64.decode(fname);
					} catch (error) {
						console.log(error);
					}
					a.download = fname;
				}else{
					a.download = Tools.getUuId();
				}

				a.style.display = "none";
				a.href = url;
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				URL.revokeObjectURL(url);
			}

			if(call){
				call(response);
			}
		},
		err=>{
			let res = err.response.data;
			let t = res.text();
			t.then(d=>{
				let json = JSON.parse(d);
				if(json.msg){
					Tools.error(json.msg);
				}else if(json.message){
					Tools.error(json.message);
				}
			});
			if(call){
				call(err.response);
			}
		}
	);

}


/**
 * 根据配置的文件模板 - 导出数据
 */
Tools.exportDataByTemp = function(params){
	if(!params || !params.templateCode){
		alert("文件模板code为空");
		return;
	}

	let url = '/sys/fileTemp/export';
	this.postDownload(url,params,params.fileName);
}

/**
 * 生成一个用不重复的ID
 * @param { Number } randomLength
 */
Tools.getUuId = function(randomLength=20){
	return Number(Math.random().toString().substr(2,randomLength) + Date.now()).toString(36);
}

/**
 * 判断list是否存在某个值
 * params = {'fieldName','value'}
 */
Tools.listIsExistVal = function(list,params={}){
	let i = -1;

	if(list && list.length>0 && params && Object.keys(params).length>0){
		for (let index = 0; index < list.length; index++) {
			const row = list[index];
			let existCount = 0;
			for (const key in params) {
				if (params.hasOwnProperty(key)) {
					if(row[key] == params[key]){
						existCount++;
					}
				}
			}
			if(existCount==Object.keys(params).length){
				i = index;
				break;
			}
		}
	}
	return i;
}

/**
 * 复制 list 行中数据
 * row 复制的数据
 * resetField 需要置空的字段
 * index 复制数据到什么位置  默认是最底部
 */
Tools.copyToList = function(list,row,resetField={},index){

	if(list && row){
		if(!index && !(index===0)){
			index = list.length;
		}
		let entity = JSON.parse(JSON.stringify(row));
		if(resetField){
			entity = {...entity,...resetField};
		}
		list.splice(index,0,entity);
	}

}

/**
 * 置空 list 某些字段值
 * resetField 需要置空的字段
 */
Tools.listRestFieldValue = function(list,resetField={}){

	if(list && list.length>0){
		list.forEach(row => {
			for (const key in resetField) {
				if (resetField.hasOwnProperty(key)) {
					const val = resetField[key];
					row[key] = val;
				}
			}
		});
	}

}


/**
 * list 转字符串
 */
Tools.listJoin = function(list,fieldName,join=","){
	let reslut = "";
	if(list && list.length>0){
		list.forEach(row => {
			let value = row[fieldName];
			if(value){
				reslut += join;
			}
		});
	}
	if(reslut){
		reslut = reslut.substring(0,reslut.length-1);
	}
	return reslut;
}

/**
 * list count累计
 */
Tools.listCountByField = function(list,fieldName,isToFixed=false){
	let reslut = 0;
	if(list && list.length>0){
		list.forEach(row => {
			let value = row[fieldName];
			if(value){
				reslut += value;
			}
		});
	}
	if(isToFixed){
		reslut = Tools.toFixed(reslut);
	}
	return reslut;
}


/**
 * 批量删除 list 行中数据
 */
Tools.listBatchDel = function(list,func){
	if(list && list.length>0){
		for (let index = 0; index < list.length; index++) {
			const row = list[index];
			if(func(row)){
				list.splice(index,1);
				index--;
			}
		};
	}

}

/**
 * list 转map
 */
Tools.listToMap = function(list,keyField){
	let map = {};
	if(list && list.length>0){
		for (let index = 0; index < list.length; index++) {
			const row = list[index];
			let keyValue = row[keyField];
			map[keyValue] = row;
		};
	}
	return map;
}

Tools.confirm = function(opt,onOk,onCancel,content){
	Vue.prototype.$Modal.confirm({
		title: $t('page.common.prompt'),
		content: content?content:$t('page.common.confirmOpts',{opt:opt}),
		onOk: ()=>{
			if(onOk){
				onOk();
			}
		},
		onCancel: ()=>{
			if(onCancel){
				onCancel();
			}
		}
	});
}

Tools.success = function(msg){
	Vue.prototype.$Modal.success({
		title: $t('page.common.prompt'),
		content: msg?msg:$t('page.common.operSuccess')
	});
}

Tools.warning = function(msg){
	Vue.prototype.$Modal.warning({
		title: $t('page.common.prompt'),
		content: msg
	});
}

Tools.error = function(msg){
	Vue.prototype.$Modal.error({
		title: $t('page.common.prompt'),
		content: msg
	});
}

//根据业务id,业务对key获取业务对象数据
Tools.queryItemById = async function(params = {}){
	/**
	 * id:品目Id
	 * itpId:品目价格Id
	 */
	return new Promise((resolve, reject) => {
		let url = 'purchase/purchaseItem/queryItemById';
		let post = Vue.abHttpUtil.postForm(url,params);
		Tools.getResultData(post, (data,result) => {
			resolve(result.rows,result);
		});
	});
}
/**
 * 校验统一社会信用代码
 */
Tools.validateUSCI = function (usci) {
    if (!usci || usci.length !== 18) {
		// 长度不是18位，直接返回false
        return false;
    }

	// 不包含I、O、S、V、Z，这些是校验码计算中不会出现的字符
    const validChars = '0123456789ABCDEFGHJKLMNPQRTUWXY';
    for (let i = 0; i < usci.length; i++) {
        if (validChars.indexOf(usci[i]) === -1) {
			// 包含非法字符，格式不正确
            return false;
        }
    }

    return true;

}

/**
 * 是否移动端
 */
Tools.isMobile = function(){
	let flag = false;
	try {
		var ua = navigator.userAgent,
		isWindowsPhone = /(?:Windows Phone)/.test(ua),
		isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
		isAndroid = /(?:Android)/.test(ua),
		isFireFox = /(?:Firefox)/.test(ua),
		isChrome = /(?:Chrome|CriOS)/.test(ua),
		isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
		isPhone = /(?:iPhone)/.test(ua) && !isTablet,
		isPc = !isPhone && !isAndroid && !isSymbian;
		// return {
		//       isTablet: isTablet,
		//       isPhone: isPhone,
		//       isAndroid : isAndroid,
		//       isPc : isPc
		// };
		if(isAndroid || isPhone || isSymbian){
			flag =  true;
		}
	} catch (error) {
		console.log(error);
	}
	return flag;
}
/**
 * 是否IOS移动端
 */
Tools.isPhoneMobile = function(){
	let flag = false;
	try {
		var ua = navigator.userAgent,
		isWindowsPhone = /(?:Windows Phone)/.test(ua),
		isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
		isAndroid = /(?:Android)/.test(ua),
		isFireFox = /(?:Firefox)/.test(ua),
		isChrome = /(?:Chrome|CriOS)/.test(ua),
		isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
		isPhone = /(?:iPhone)/.test(ua) && !isTablet,
		isPc = !isPhone && !isAndroid && !isSymbian;
		if(isPhone){
			flag =  true;
		}
	} catch (error) {
		console.log(error);
	}
	return flag;
}

//手签-校验文件是否指定了签署位置
Tools.sfsSignCheckFileIsSetSignPoit = async function(params = {}){
	return new Promise((resolve, reject) => {
		let url = '/sfsSign/checkFileIsSetSignPoit';
		let post = Vue.abHttpUtil.post(url,params);
		Tools.getResultData(post, (data,result) => {
			resolve(data);
		},'alert',err=>{
			resolve();
		});
	});
}

/**
 * SFS - 手签
 */
Tools.toSfsHandSign = async function(params={},call,closeCall){

	/* let pageParams = params;
	//base64加密
	let pageParamsBase64 = Base64.encode(JSON.stringify(pageParams));;
	let routeUrl = Router.resolve({
		name: 'otherIframePage',
		query: {
			pageType:'sfsHandSign',
			pageParams:pageParamsBase64
		}
	})
	let pageUrl = routeUrl.href;
	let authorization = Router.app.$route.query.Authorization;
	if(authorization){
		pageUrl += "&Authorization="+authorization;
	}
	let winURL = window.open(pageUrl, '_blank',"width=1920,height=1080,menubar=0,scrollbars=1,resizable=1,status=1,titlebar=0,toolbar=0,location=1");
	//监听关闭事件
	const loop = setInterval(() => {    // 使用定时器查询当前状态
		if (winURL && winURL.closed) {  // 进行判断条件   closed属性就是返回当前窗口的状态
			clearInterval(loop);       // 清除定时器
			if(closeCall){
				closeCall();
			}
		}
	}, 500); */

	let isLoadingEnd = false;
	let pageUrl = '';

	let url = '/sfsSign/toSign';
	let post = Vue.abHttpUtil.post(url, {...params});
	Tools.getResultData(post, (data,result) => {
		if(call){
			call(data);
		}
		if(data){
			pageUrl = data;
		}
		isLoadingEnd = true;

		if(params.isNoOpenPage!='Y'){
			if(pageUrl){
				//是否IOS
				let isPhoneMobile_ = Tools.isPhoneMobile();
				if(isPhoneMobile_){
					try {
						//跳转到手签页面
						let fanweiUrl = document.referrer;
						window.parent.postMessage(
							{
								type: 'sclmToOtherPage',//类型 跳转到其他页面
								msg:'',
								otherPageUrl:pageUrl
							},
							fanweiUrl
						);
					} catch (error) {
						console.log(error);
					}
					//window.location.href=pageUrl;
				}else{
					let winURL = window.open(pageUrl, '_blank',"width=1920,height=1080,menubar=0,scrollbars=1,resizable=1,status=1,titlebar=0,toolbar=0,location=1");
					//监听关闭事件
					const loop = setInterval(() => {    // 使用定时器查询当前状态
						if (winURL && winURL.closed) {  // 进行判断条件   closed属性就是返回当前窗口的状态
							clearInterval(loop);       // 清除定时器
							if(closeCall){
								closeCall();
							}
						}
					}, 500);
				}
			}
		}

	},'alert',err=>{
		isLoadingEnd = true;
		if(call){
			call();
		}
	});

	/* if(params.isNoOpenPage!='Y'){
		const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));
		let flag = true;
		while (flag) {
			//console.log(new Date().getTime());
			if(isLoadingEnd){
				flag = false;
				if(pageUrl){
					let winURL = window.open(pageUrl, '_blank',"width=1920,height=1080,menubar=0,scrollbars=1,resizable=1,status=1,titlebar=0,toolbar=0,location=1");
					//监听关闭事件
					const loop = setInterval(() => {    // 使用定时器查询当前状态
						if (winURL && winURL.closed) {  // 进行判断条件   closed属性就是返回当前窗口的状态
							clearInterval(loop);       // 清除定时器
							if(closeCall){
								closeCall();
							}
						}
					}, 500);
				}
			}else{
				await sleep(300);
			}
		}
	} */

	/* let inter = setInterval(() => {
		if(isLoadingEnd){
			clearInterval(inter);
			if(pageUrl){
				//alert(pageUrl);
				let winURL = window.open(pageUrl, '_blank',"width=1920,height=1080,menubar=0,scrollbars=1,resizable=1,status=1,titlebar=0,toolbar=0,location=1");

				//监听关闭事件
				const loop = setInterval(() => {    // 使用定时器查询当前状态
					if (winURL && winURL.closed) {  // 进行判断条件   closed属性就是返回当前窗口的状态
						clearInterval(loop);       // 清除定时器
						if(closeCall){
							closeCall();
						}
					}
				}, 500);
			}
		}
	}, 300); */

}
//====================liuhaijiang=========================

Tools.loginToast= true;
export default {
  // 全局安装时候
  install (Vue) {
    Vue.abTools = Tools;
    Vue.prototype.abTools = Tools;
  },
  AbTools: Tools
}

